import type { Headers, Params } from './types'

const ImsDataService = class {
  headers: Headers
  imsUrl: Params['imsUrl']
  apiFetch: Params['apiFetch']

  constructor (params: Params) {
    this.apiFetch = params.apiFetch
    this.imsUrl = params.imsUrl
    this.headers = {
      'X-Application-Id': params.xApplicationId,
      'x-api-key': params.xApiKey,
      'Content-Type': 'application/json'
    }
  }

  async getUnit (projectCode: string, unitCode: string) {
    try {
      const endpoint = `${this.imsUrl}/catalog_api/v1/projects/${projectCode}/properties/${unitCode}?version=2`
      return await this.apiFetch(endpoint, {
        method: 'GET',
        headers: {
          ...this.headers
        }
      })
    } catch (error: any) {
      throw new Error(error)
    }
  }

  async getPaymentPlan (projectCode: string, typologyName: string) {
    try {
      const params = {
        name: typologyName
      }
      const endpoint = `${this.imsUrl}/catalog_api/v1/projects/${projectCode}/typology_payment_plan`
      const result = await this.apiFetch(endpoint, {
        method: 'GET',
        headers: {
          ...this.headers
        },
        params
      })

      if (!result) throw new Error('No payment plan found')

      return result
    } catch (error: any) {
      throw new Error(error)
    }
  }
}

export default ImsDataService
